<script>
import ResponsiveMenu from '@/components/ResponsiveMenu/ResponsiveMenu'
import ResponsiveMenuItem from '@/components/ResponsiveMenu/ResponsiveMenuItem'
import LocalStorageUtils from '@/utils/localStorageUtils'

export default
{
    mixins: [ResponsiveMenu],

    name: 'main-menu',

    props: { orientation: {default: 'horizontal'} },

    created ()
    {
        window.app.mainMenu = this
    },

    render () 
    {
        const userPrivileges = this.$store.state.user.privileges
        const hasUserAnyPrivilege = Object.values(userPrivileges).some(privilege => privilege == true)

        return (
            <responsive-menu id='main-menu' orientation={this.barOrientation} visible={this.isVisible} on-item-selected={this.onItemSelected}>
                <responsive-menu-item icon={require('@/assets/img/home.svg')} name='accueil' id='home' />
                <responsive-menu-item icon={require('@/assets/img/heart.svg')} name='favoris' id='favorites' />
                <responsive-menu-item icon={require('@/assets/img/pencil.svg')} name='édition' id='edit' v-show={hasUserAnyPrivilege} />
                <responsive-menu-item icon={require('@/assets/img/bell.svg')} name='notifications' id='notifications' notification-dot-active={this.hasUnseenNotification} />
                <responsive-menu-item icon={require('@/assets/img/gear.svg')} name='paramètres' id='settings' />
            </responsive-menu>
        )
    },

    data () 
    {
        return {
            barOrientation: this.orientation,
            isVisible: true,
        }
    },

    computed:
    {
        latestNotification ()
        {
            const notifications = this.$store.getters.notifications.notificationsByDate
            
            return (notifications[Object.keys(notifications)[0]] || [])[0]
        },

        hasUnseenNotification ()
        {
            if (!this.latestNotification) return false

            const lastNotificationSeen = LocalStorageUtils.observables.lastNotificationSeen
            const a = lastNotificationSeen
            const b = this.latestNotification

            return (!a || !a.element || a.element.id != b.element.id || a.element.date != b.element.date || a.type != b.type)
        }
    },

    watch:
    {
        orientation ()
        {
            this.barOrientation = this.orientation
        },
    },

    mounted ()
    {
        this.barOrientation = this.orientation

        // When route changes but was not made from the menu bar.
        const afterEach = (to, from) =>
        {
            const item = this.getMenuItems().find(i => to.path.startsWith('/' + i.id))
            if (item)
            {
                this.selectMenuItem(item)
            }

            this.isVisible = to.meta.hideMainMenu ? false : true
        }

        this.$router.afterEach(afterEach)
        afterEach(this.$route)
    },

    methods:
    {
        async onItemSelected (menuItem)
        {
            const path = '/' + menuItem.id
            console.log('Navigating to menu index ' + path)

            try
            {
                await this.$router.push(path)

                if (path.includes('notifications'))
                {
                    LocalStorageUtils.observables.lastNotificationSeen = this.latestNotification
                }
            }
            catch (e)
            {
                console.log('Navigation aborted', e)
            }
        },
    },

    components:
    {
        ResponsiveMenu,
        ResponsiveMenuItem
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#main-menu
{
    &.responsive-menu.vertical
    {
        left: 0;
        width: var(--theme-vertical-menu-width);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue